export default __webpack_public_path__ + "static/media/ijert_certificate.79a0d7cf.png";